import { types } from '../../../constants/ActionTypes'

const initialState = {
  width: 0,
  height: 0,
}

const window = (state = initialState, action) => {
  switch (action.type) {
    case types.window.RESIZE:
      return { ...state, width: action.width, height: action.height }
    default:
      return state
  }
}

export default window


// WEBPACK FOOTER //
// ./src/reducers/Common/Window/Window.js